import type { ReactNode } from "react";
import { cn } from "web-design-system";

type ReportSectionProps = {
  sectionId: string;
  visible?: boolean;
  children: ReactNode;
  className?: string;
};

export function ReportSection({
  sectionId,
  visible = true,
  children,
  className,
}: ReportSectionProps) {
  if (!visible) return null;

  return (
    <section className={cn("break-inside-avoid", className)} id={sectionId}>
      {children}
    </section>
  );
}
